module.exports = __webpack_public_path__ + "img/business.3ccd7e80.svg";